import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import styles from "./styles/EventLogs.module.css"
import TableFilter from "./TableFilter";
import { EventTable } from "./EventTable";
import TableFooter from "./TableFooter";
import config from "../../../config";
import { formatDate } from "../../../Utils/formatDate";
import Loading from "../../Loading/Loading";

const base_url=config.base_url
function EventLogs() {
  const [data, setData]=useState([])
  const [loaded, setLoaded] = useState(false)
  const [filter, setFilter] = useState({
    "filter_value":"",
    "filter_field":"user_id",
    "max_date":Date.now(),
    "min_date":Date.now()-1000*60*60*24*7,
    "sort":"-date",
    "nlogs":"20",
    "page":1,
  })
  const [maxPages, setmaxPages] = useState(1)
  const RequestData = (filter) =>{
    fetch(base_url+'admin/EventLogs',{
      method: 'POST',
      mode: 'cors',
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-type': 'application/x-www-form-urlencoded',
          'credentials':'include'
      },
      body: `filter_value=${filter.filter_value}&filter_field=${filter.filter_field}&max_date=${filter.max_date}&min_date=${filter.min_date}&nlogs=${filter.nlogs}&page=${filter.page}&sort=${filter.sort}`,
      credentials:'include'
    }).then(res=>res.json())
    .then((data)=>{
      if (data.error) alert('')
      else{

        if (data.result.total===0) setmaxPages(1)
        else setmaxPages(Math.ceil(data.result.total/filter.nlogs))
        setData(data.result.data)
        setLoaded(true)

      }
    })
  }
  const DownloadCSV = (filter) =>{
    fetch(base_url+'admin/EventLogs/download',{
      method: 'POST',
      mode: 'cors',
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-type': 'application/x-www-form-urlencoded',
          'credentials':'include'
      },
      body: `filter_value=${filter.filter_value}&max_date=${filter.max_date}&min_date=${filter.min_date}`,
      credentials:'include'
    })
    .then(res=>{
      if (res.status!==200) throw new Error('Response status is not 200');
      else return  res.blob()
    }).then((blob)=>{
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'EventLogs.csv');
      document.body.appendChild(link);
      link.click();
    })
  }
  useEffect(() => {
    RequestData(filter)
  }, [filter]);
  useEffect(()=>{
    handleChange(1, "page")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxPages])
  const columns = useMemo(()=>[
    {
        Header: "User ID",
        accessor: "user_id",
        disableSortBy: true,
        Cell:({row, value})=>{
          return (<span>{value}</span>)
        }
    },
    {
        Header: "User Type",
        accessor: "user_type",
        disableSortBy: true,
        Cell:({row, value})=>{
          return (<span>{value}</span>)
        }
    },
    {
        Header: "Date",
        accessor: "date",
        disableSortBy: true,
        Cell: ({row,value})=>{
          return (<span>{formatDate(value).split(" ")[0]}</span>)
        }
    },
    {
        Header: "Time",
        disableSortBy: true,
        Cell: ({row})=>{
          const value = row.values.date
          return (<span>{formatDate(value).split(" ")[1]}</span>)
        }
    },
    {
      Header: "Event Name",
      accessor: "event_name",
      disableSortBy: true,
      Cell: ({ row, value }) => {
        return (<span>{value}</span>) 
      }
    }], []);
  const handleChange = (value, field) =>{
    setFilter({...filter,[field]:value})
  }

  return (
    <div className={styles.main_box}>
        <h1>Event Logs</h1>
        {/* <h2 className={styles.sub_title}>What are assets</h2> */}
        <div className={styles.table_div}>
          <TableFilter filter={filter} setFilter={setFilter} handleChange={handleChange} DownloadCSV={DownloadCSV}/>
          {loaded?<><EventTable columns={columns} data={data} filter={filter} setFilter={setFilter} handleChange={handleChange}/>
          <TableFooter filter={filter} setFilter={setFilter} maxPages={maxPages} handleChange={handleChange}/></>:<Loading text={'Loading Event Logs...'}/>}
        </div>
    </div>    
  );
}

export default EventLogs;
